<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P225F0001">
    <div class="form-row mt-3">
        <div class="form-field">
            <p-dropdown formControlName="vendedor" 
            [options]="usuariosDropdown" 
            optionLabel="susuario"
            optionValue="susuario" 
            [filter]="true" 
            [showClear]="true" appendTo="body"
            placeholder="Seleccione clave vendedor"
            class="w-100" appPermissionControl="P225K0001"
            (onChange)="onVendedorSelected($event.value)">
                <ng-template let-user pTemplate="item">
                    {{ user.susuario }} | {{ user.nombreusuario }}
                </ng-template>
            </p-dropdown>
            <label>Clave Vendedor</label>
        </div>

        <div class="form-field">
            <p-dropdown formControlName="tipo" 
                [options]="tiposDropdown" 
                optionLabel="label"
                optionValue="value" 
                appendTo="body"
                placeholder="Seleccione tipo"
                class="w-100" appPermissionControl="P225K0002">
            </p-dropdown>
            <label>Tipo</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="exterior" class="form-control"
                [placeholder]="'Ingrese exterior'" appPermissionControl="P225K0003">
            <label>Exterior</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="oficinaTramite" class="form-control"
                [placeholder]="'Ingrese oficina trámite'" appPermissionControl="P225K0004">
            <label>Oficina Trámite</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="regional" class="form-control"
                [placeholder]="'Ingrese regional'" appPermissionControl="P225K0005">
            <label>Regional</label>
        </div>

        <div class="form-field">
            <p-dropdown formControlName="estado" 
                [options]="estadosDropdown" 
                optionLabel="label"
                optionValue="value" 
                appendTo="body"
                placeholder="Seleccione estado"
                class="w-100" appPermissionControl="P225K0006">
            </p-dropdown>
            <label>Estado</label>
        </div>

        <div class="form-field">
            <input pInputText type="number" formControlName="telefono" class="form-control"
                [placeholder]="'Ingrese teléfono'" min="0" appPermissionControl="P225K0007">
            <label>Teléfono</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="nombre" class="form-control"
                [placeholder]="'Ingrese nombres'" appPermissionControl="P225K0008" disabled>
            <label>Nombres</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="cedula" class="form-control"
                [placeholder]="'Ingrese cédula'" appPermissionControl="P225K0009">
            <label>Cédula</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="interior" class="form-control"
                [placeholder]="'Ingrese interior'" appPermissionControl="P225K0010">
            <label>Interior</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="cargo" class="form-control"
                [placeholder]="'Ingrese cargo'" appPermissionControl="P225K0011">
            <label>Cargo</label>
        </div>

        <div class="form-field">
            <input pInputText type="text" formControlName="ciudad" class="form-control"
                [placeholder]="'Ingrese ciudad'" appPermissionControl="P225K0012">
            <label>Ciudad</label>
        </div>

        <div class="form-field">
            <input pInputText type="number" formControlName="cp" class="form-control"
                [placeholder]="'Ingrese código postal'" min="0" appPermissionControl="P225K0013">
            <label>C.P</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P225B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P225B0002">
            <mat-icon>settings</mat-icon>
            Customizables
        </button>
    </div>
</form>

<style>
    :host ::ng-deep .form-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    :host ::ng-deep .form-field {
        flex: 1 1 calc(25% - 1rem);
        min-width: 200px;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }

    :host ::ng-deep .form-control {
        width: 100%;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        background: #fff;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    :host ::ng-deep .form-control:disabled,
    :host ::ng-deep .form-control[disabled],
    :host ::ng-deep .form-control[readonly] {
        background: #e0e0e0 !important;
        color: #555 !important;
        opacity: 1 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
    }

    :host ::ng-deep .form-field label {
        font-size: 0.85rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }

    :host ::ng-deep .form-field:has(.form-control:disabled) label,
    :host ::ng-deep .form-field:has(.form-control[disabled]) label,
    :host ::ng-deep .form-field:has(.form-control[readonly]) label {
        color: #555 !important;
    }

    :host ::ng-deep .button-section {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    :host ::ng-deep .p-dropdown {
        width: 100%;
    }

    :host ::ng-deep .p-dropdown.p-disabled,
    :host ::ng-deep .p-dropdown[disabled] {
        pointer-events: none !important;
        opacity: 0.7 !important;
        background-color: #e0e0e0 !important;
        cursor: not-allowed !important;
    }

    :host ::ng-deep .p-dropdown.p-disabled .p-dropdown-trigger,
    :host ::ng-deep .p-dropdown[disabled] .p-dropdown-trigger {
        display: none !important;
    }

    :host ::ng-deep .p-dropdown.p-disabled .p-dropdown-panel,
    :host ::ng-deep .p-dropdown[disabled] .p-dropdown-panel {
        display: none !important;
    }

    :host ::ng-deep .p-dropdown.p-disabled .p-dropdown-label,
    :host ::ng-deep .p-dropdown[disabled] .p-dropdown-label {
        color: #555 !important;
    }
</style> 